import { Award, Landmark, Building2, Users, GraduationCap, Plane, ArrowRight, Calendar } from 'lucide-react';

const ServicesPage = () => {
  const whatsappBase = "https://wa.me/522282728556?text=";
  
  const services = [
    {
      id: '1',
      title: 'Congresos y Conferencias',
      description: 'Acceso a los eventos académicos y profesionales más importantes de tu industria.',
      longDescription: 'Te llevamos a los congresos más relevantes donde podrás aprender de expertos mundiales, obtener certificaciones y hacer networking con profesionales de tu área.',
      icon: Award,
      image: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&h=600&fit=crop',
      ctaText: 'Conocer Congresos Disponibles',
      whatsappMessage: 'Hola, me interesa conocer qué congresos tienen disponibles para mi carrera',
    },
    {
      id: '2',
      title: 'Visitas a Museos',
      description: 'Experiencias culturales en los museos más reconocidos a nivel mundial.',
      longDescription: 'Diseñamos visitas guiadas con contenido académico de valor. Desde el Louvre hasta el MoMA, museos de ciencia, tecnología y arte.',
      icon: Landmark,
      image: 'https://images.unsplash.com/photo-1554907984-15263bfd63bd?w=800&h=600&fit=crop',
      ctaText: 'Ver Museos Disponibles',
      whatsappMessage: 'Hola, me interesa conocer qué museos pueden incluir en un viaje académico',
    },
    {
      id: '3',
      title: 'Visitas Empresariales',
      description: 'Conoce de cerca las empresas líderes y aprende de los mejores.',
      longDescription: 'Organizamos visitas a corporativos nacionales e internacionales: BMW, Bimbo, Bolsa de Valores, BBVA, PwC, EY y muchas más.',
      icon: Building2,
      image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&h=600&fit=crop',
      ctaText: 'Ver Empresas Disponibles',
      whatsappMessage: 'Hola, me interesa conocer qué empresas pueden visitar con ustedes',
    },
    {
      id: '4',
      title: 'Networking Académico',
      description: 'Conecta con estudiantes y profesionales de todo el mundo.',
      longDescription: 'Facilitamos espacios de networking que pueden cambiar tu carrera. Eventos exclusivos, mesas redondas y encuentros con líderes de la industria.',
      icon: Users,
      image: 'https://images.unsplash.com/photo-1515187029135-18ee286d815b?w=800&h=600&fit=crop',
      ctaText: 'Conocer Eventos de Networking',
      whatsappMessage: 'Hola, me interesa conocer eventos de networking académico',
    },
    {
      id: '5',
      title: 'Campus Tours',
      description: 'Visitas guiadas a las universidades más prestigiosas del mundo.',
      longDescription: 'Conoce Harvard, MIT, Stanford, UNAM, TEC y muchas más. Recorridos con información académica, requisitos de admisión y experiencia de campus.',
      icon: GraduationCap,
      image: 'https://images.unsplash.com/photo-1562774053-701939374585?w=800&h=600&fit=crop',
      ctaText: 'Ver Universidades Disponibles',
      whatsappMessage: 'Hola, me interesa conocer qué universidades pueden visitar',
    },
    {
      id: '6',
      title: 'Logística Completa',
      description: 'Transporte, hospedaje, seguros y todo lo que necesitas.',
      longDescription: 'Nos encargamos de cada detalle: vuelos, hoteles con desayuno, traslados, seguros médicos internacionales y coordinación total.',
      icon: Plane,
      image: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=800&h=600&fit=crop',
      ctaText: 'Solicitar Cotización',
      whatsappMessage: 'Hola, me interesa cotizar un viaje académico completo',
    },
  ];

  return (
    <main data-testid="services-page" className="bg-[#0a0a0a]">
      {/* Hero Section */}
      <section className="relative h-[50vh] min-h-[400px] flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1475721027785-f74eccf877e2?auto=format&fit=crop&w=1920&q=80"
            alt="Services"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#1A1A1A]/95 via-[#1A1A1A]/70 to-[#1A1A1A]/50" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12">
          <span className="inline-block text-[#009DE0] font-semibold text-sm uppercase tracking-wider mb-4">
            Nuestros Servicios
          </span>
          <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight">
            Experiencias que
            <br />
            <span className="text-[#009DE0]">transforman carreras</span>
          </h1>
          <p className="text-white/70 text-lg mt-6 max-w-xl">
            Diseñamos viajes académicos a la medida de tu institución y carrera.
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service) => {
              const IconComponent = service.icon;
              return (
                <div
                  key={service.id}
                  data-testid={`service-card-${service.id}`}
                  className="group bg-white rounded-2xl overflow-hidden border border-gray-100 hover:border-[#009DE0]/30 hover:shadow-xl transition-all duration-300"
                >
                  {/* Image */}
                  <a 
                    href={`${whatsappBase}${encodeURIComponent(service.whatsappMessage)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block relative h-52 overflow-hidden cursor-pointer"
                  >
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#1A1A1A]/70 to-transparent" />
                    <div className="absolute bottom-4 left-4">
                      <div className="w-12 h-12 bg-[#009DE0] rounded-xl flex items-center justify-center">
                        <IconComponent size={24} className="text-white" />
                      </div>
                    </div>
                    {/* Hover overlay */}
                    <div className="absolute inset-0 bg-[#009DE0]/80 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                      <span className="text-white font-bold text-lg">Click para cotizar</span>
                    </div>
                  </a>

                  {/* Content */}
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-[#1A1A1A] mb-2">
                      {service.title}
                    </h3>
                    <p className="text-[#1A1A1A]/80 font-medium mb-2">
                      {service.description}
                    </p>
                    <p className="text-[#1A1A1A]/50 text-sm leading-relaxed mb-5">
                      {service.longDescription}
                    </p>
                    
                    {/* Action Buttons */}
                    <div className="flex flex-col gap-2">
                      <a
                        href={`${whatsappBase}${encodeURIComponent(service.whatsappMessage)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center justify-center gap-2 bg-[#009DE0] text-white px-4 py-3 rounded-xl font-semibold text-sm hover:bg-[#007BB0] transition-all"
                      >
                        <Calendar size={16} />
                        {service.ctaText}
                      </a>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-24 bg-[#F8F9FA]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <span className="text-[#009DE0] font-semibold text-sm uppercase tracking-wider">Nuestro Proceso</span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#1A1A1A] mt-3">
              ¿Cómo trabajamos?
            </h2>
          </div>

          <div className="grid md:grid-cols-4 gap-8">
            {[
              { step: '01', title: 'Contacto', desc: 'Cuéntanos sobre tu proyecto de viaje académico' },
              { step: '02', title: 'Cotización', desc: 'Recibe tu propuesta en menos de 24 horas' },
              { step: '03', title: 'Planificación', desc: 'Diseñamos cada detalle de tu experiencia' },
              { step: '04', title: 'Viaje', desc: 'Disfruta de una experiencia inolvidable' },
            ].map((item, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 mx-auto bg-[#009DE0] rounded-full flex items-center justify-center mb-5">
                  <span className="text-white font-bold text-xl">{item.step}</span>
                </div>
                <h3 className="text-lg font-bold text-[#1A1A1A] mb-2">{item.title}</h3>
                <p className="text-[#1A1A1A]/60 text-sm">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-[#1A1A1A]">
        <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            ¿Listo para vivir una
            <span className="text-[#009DE0]"> experiencia única</span>?
          </h2>
          <p className="text-white/60 text-lg mb-10">
            Cuéntanos sobre tu proyecto y diseñemos juntos el viaje perfecto.
          </p>
          <a
            href="https://wa.me/522282728556?text=Hola,%20me%20interesa%20cotizar%20un%20viaje%20académico"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#009DE0] text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-[#007BB0] transition-all"
          >
            <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
            </svg>
            Solicitar Cotización por WhatsApp
            <ArrowRight size={20} />
          </a>
        </div>
      </section>
    </main>
  );
};

export default ServicesPage;
